const Page = (videos) => {
    const view = videos.posts
      .map((video) => {
        return `
        <div class="video-gallery__item">
        <div class="video-gallery__item-wrapper">
            
                <figure class="video-series__thumbnail">
  
                    <img src="${video['video-thumbnail-url']}" alt="Image thumbnail" class="video_thumbnail">
  
                    <a class="cw_video_open_popup_customized video-thumbnail-play" href="javascript:void(0);" video_id="${video['video-id']}" video_autoplay="1" video_type="${video['video-type']}" video_showinfo="" video_rel="0" aria-label="Click to open video on a popup">
                        <img src="/wp-content/themes/horizon-discovery/dist/images/icons/play-video.svg" alt="Play Icon">
                    </a>
                </figure>
  
                <div class="video-gallery__item-content">
                <a href="${video['item-permalink']}" aria-label="Click to open" class="video-gallery__item-title">${video['item-title']}</a>
                <div class="video-gallery__item-description">${video['short-description']}</div>
                
                
                <div class="video-gallery__item-length">
						<img class="icon" src="/wp-content/themes/horizon-discovery/dist/images/icons/clock.svg" >
						${video['video_length']}
				</div>
            </div>
        </div>
    </div>
        `;
      })
      .join('');
  
    return view;
  };
  
  export default Page;
  